import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    CircularProgress,
} from "@mui/material";
import { useLocation } from "react-router-dom";

import CustomTable from "../../components/common/CustomTable";
import { clientApi } from "../../api/tenantApi";

export default function TenantTokenUsagePage() {
    const location = useLocation();
    // console.log(location.state)
    const tenantId = location.state?.tenantId;
    const tenantName = location.state?.tenant_name;// ✅ get from previous page

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    /* ── Fetch Token Usage ───────────────────────── */

    const fetchTokenUsage = async () => {
        if (!tenantId) return; // safety

        setLoading(true);
        try {
            const payload = {
                tenant_id: tenantId, // ✅ send tenant_id
            };

            const response = await clientApi.getTenantToken(payload);

            const { status, data } = response || {};

            if (status === 200 && Array.isArray(data)) {
                setRows(data);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error("Error fetching token usage:", error);
            setRows([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTokenUsage();
    }, [tenantId]);

    /* ── Columns ───────────────────────── */

    const columns = [
        { label: "Email", field: "email" },
        { label: "Full Name", field: "full_name" },
        { label: "Process", field: "process" },
        { label: "Input Tokens", field: "input_token" },
        { label: "Output Tokens", field: "output_token" },
        { label: "Total Tokens", field: "total_tokens" },
        {
            label: "Used At",
            field: "used_at",
            render: (value) =>
                value ? new Date(value).toLocaleString("en-IN") : "—",
        },
    ];

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight={600} mb={2}>
                Token Usage (Tenant {tenantName || "N/A"})
            </Typography>

            {!tenantId ? (
                <Typography color="error">
                    No Tenant ID found. Please navigate from Tenant page.
                </Typography>
            ) : loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <CustomTable columns={columns} rows={rows} />
            )}
        </Box>
    );
}